import type { RecruitingInsightsResponse } from "@repo/app-types/entities/recruitingInsights";
import { getTagsProvidedByEntity, TagType } from "../helpers/tags.js";
import { api } from "../redux.js";

export interface RecruitingInsightsQueryArg {
  readonly projectId: string;
  // Inclusive lower bound on `interview.started_at`, ISO-8601. Omit for
  // unbounded (all-time).
  readonly from?: string;
  // Exclusive upper bound on `interview.started_at`, ISO-8601. Omit for
  // unbounded (all-time).
  readonly to?: string;
  // IANA time zone (e.g. `America/New_York`) used to bucket the time
  // series chart by calendar day.
  readonly timeZone: string;
}

const recruitingInsightsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    recruitingInsights: builder.query<
      RecruitingInsightsResponse,
      RecruitingInsightsQueryArg
    >({
      query: ({ projectId, from, to, timeZone }) => ({
        url: `/insights/recruiting/${encodeURIComponent(projectId)}`,
        params: { from, to, timeZone },
      }),
      providesTags: (_result, _error, { projectId }) =>
        getTagsProvidedByEntity(TagType.RecruitingInsights, projectId),
    }),
  }),
});

export const { useRecruitingInsightsQuery } = recruitingInsightsApi;
